import * as core from '../../../../../../../core'

import { query } from './change-impacts-by-status.query'

export const RESOURCE = {
  payload: {
    alias: 'change.impacts.by.status',
    description: 'Chart view of change impacts by status',
    name: 'Change Impacts by Status',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
